import LandingHeader from "../../components/AppHeader/LandingHeader";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import { useState, useEffect } from "react";
import Typography from "../../components/Typography/Typography";
import { CodeXml } from "lucide-react";

export default function BaseSiteLayout({ isBeta, isNoPadding, children }) {
  const [headerHeight, setHeaderHeight] = useState(0);
  const isMobile = typeof window !== "undefined" ? window.innerWidth <= 768 : false;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full min-h-screen flex flex-col bg-gray-50">
      <LandingHeader
        isBeta={isBeta}
        setHeaderHeight={setHeaderHeight}
        headerHeight={headerHeight}
      />

      <div className="cursor-pointer flex w-full justify-center items-center bg-accent py-4 text-white" onClick={() =>
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        })
      }>
        <CodeXml size="18" className="mr-4" />
        <Typography
          color="white"
          size="16"
          weight="md"
          align="center"
        >
          Iscriviti per accedere alla beta di Athena
        </Typography>
      </div>

      <main
        className={`w-full flex-grow bg-gray-50 overflow-x-hidden ${isNoPadding ? "" : "px-5 md:px-[40px]"}`}
        style={{
          ...(isNoPadding ? {} : { paddingTop: isMobile ? "24px" : `${headerHeight}px` }),
        }}
      >
        {children}
      </main>

      <LandingFooter />
    </div>
  );
}
